const ChevronLeft = () => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.7686 15.793C12.4687 16.0787 11.994 16.0672 11.7083 15.7672L6.70694 10.5168C6.43102 10.2271 6.43102 9.77187 6.70694 9.4822L11.7083 4.23173C11.994 3.93181 12.4687 3.92028 12.7686 4.20597C13.0685 4.49166 13.0801 4.96639 12.7944 5.26631L8.2858 9.99949L12.7944 14.7327C13.0801 15.0326 13.0685 15.5073 12.7686 15.793Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default ChevronLeft;
